import * as Api from '@/helpers/restApi'

export default {
  state: {
    BasicInformationData: null
  },
  getters: {
    getBasicInformationData: state => state.BasicInformationData
  },
  mutations: {
    SetBasicInformationData (state, val) {
      state.BasicInformationData = val
    },
    SetAddBlockBasicInformation (state, val) {
      state.BasicInformationData?.Block1.push(val)
    },
    SetRemoveBlockBasicInformation (state, val) {
      state.BasicInformationData?.Block1.forEach((item, i) => {
        if (item.GUID !== undefined && item.GUID === val) {
          state.BasicInformationData?.Block1.splice(i, 1)
        }
      })

      state.BasicInformationData?.Block1.forEach((item, i) => {
        if (item.GUID === undefined && item.Id === val) {
          state.BasicInformationData?.Block1.splice(i, 1)
        }
      })
    }
  },
  actions: {
    setBasicInformationData ({ state, dispatch, commit }, id) {
      // получаем данные для блока основных сведений раздела сведения об образовательной организации
      Api.getApi({
        url: '/api/EduCompanyInfo/GetMainInfoSection'
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            commit('SetBasicInformationData', data.Data)
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setUpdateBasicInformation ({ dispatch }, obj) {
      // обновляем блок
      Api.putApi({
        url: '/api/EduCompanyInfo/UpdateMainInfoSection',
        payload: obj
      }, 'education')
        .then((data) => {
          if (!data.Succeeded) {
            dispatch('setShowErrorModal', data)
          }
        })
    }
  }
}
